import { LoggedError } from "./LoggedError";

export class SdkError extends LoggedError {
  constructor(error) {
    super(error, LoggedError.error);
    this.name = "SdkError";
  }
}
